import React, { FC, useEffect, useState } from 'react';
import Swal from 'sweetalert2';
import { useTranslation } from 'react-i18next';
import { SCUIContent } from '../../atomic/organisms';
import { Grid } from '@mui/material';
import { SCUIBreadCrumb, SCUITextFieldWithSelectBox } from '../../atomic/molecules';
import CustomerQuery from '../../services/query/customer/CustomerQuery.services';
import { CustomerCardPaper } from './components/CustomerCardPaper/CustomerCardPaper';
import { CustomerMenuPaper } from './components/CustomerMenuPaper/CustomerMenuPaper';
import { CustomerInformationPaper } from './components/CustomerInformationPaper/CustomerInformationPaper';
import { CustomerUnderMenuPaper } from './components/CustomerUnderMenuPaper/CustomerUnderMenuPaper';
import { useHistory, useLocation } from 'react-router-dom';
import { CustomerOrderInformationPaper } from './components/CustomerOrderInformationPaper/CustomerOrderInformationPaper';
import { CustomerAdressInformationPaper } from './components/CustomerAdressInformationPaper/CustomerAdressInformationPaper';
import { CustomerReturn } from './components/CustomerReturn/CustomerReturn';
import { CustomerGiftCard } from './components/CustomerGiftCard/CustomerGiftCard';
import { CustomerLcwMoney } from './components/CustomerLcwMoney/CustomerLcwMoney';
import { CustomerRefundListV2 } from './components/CustomerRefundListV2/CustomerRefundListV2';
import { GiftVouchers } from './components/GiftVouchers/GiftVouchers';

import { CustomerContactMessage } from './components/CustomerContactMessages/CustomerContactMessage';
import { CustomerPaymentMethods } from './components/CustomerPaymentMethods/CustomerPaymentMethods';
import { CustomerShipmentBans } from './components/CustomerShipmentBans/CustomerShipmentBans';
import { CustomerShippingHistory } from './components/CustomerShippingHistory/CustomerShippingHistory';
import { SCUINoRecordComponent, SCUILoadingLinear } from '../../atomic/atoms';
import customer from '../../assets/icons/svg/pageIcons/customer.svg';
import { CustomerPaymentLogs } from './components/CustomerPaymentLogs/CustomerPaymentLogs';
import { CustomerBasketInfosV2 } from './components/CustomerBasketInfosV2/CustomerBasketInfosV2';
import { GetCustomerDeviceDetails } from './components/GetCustomerDeviceDetails/GetCustomerDeviceDetails';

interface ITabDataVisibilityStatus {
    showAddressInformation: boolean;
    showCustomerInformation: boolean;
    showCustomerBasketV2: boolean;
    showCustomerCookieApproval: boolean;
    showCustomerPaymentLogs: boolean;
    showCustomerShipmentBans: boolean;
    showCustomerShippingChangeHistory: boolean;
    showDeviceIPInformation: boolean;
    showGiftCard: boolean;
    showGiftVoucher: boolean;
    showLcwMoney: boolean;
    showMessages: boolean;
    showOrderInformation: boolean;
    showPaymentMethods: boolean;
    showReturnCustomer: boolean;
    showReturnPaymentList: boolean;
    showReasonContact: boolean;
    showRptHistory: boolean;
    showLinkedAccounts: boolean;
    communicationPreferenceV2: boolean;
}

export const CustomerManagement: FC<any> = () => {
    const [datas, setDatas] = React.useState<any>();
    const [tabList, setTablist] = React.useState<any>();
    const [customerId, setCustomerId] = React.useState<number>(0);
    const [refresh, setRefresh] = useState(false);
    const [index, setIndex] = useState(1);
    const [pageLoading, setPageLoading] = useState(false);
    const [tabDataVisibilityStatus, setTabDataVisibilityStatus] = useState<ITabDataVisibilityStatus | null>(null);
    const [tabIndex, setTabIndex] = useState<any>(1);
    const [documentType, setDocumentType] = React.useState(1);
    const [searchedText, setSearchedText] = useState('');

    const location = useLocation();
    const search = location.search;
    const history = useHistory();
    const searchParams = new URLSearchParams(search);
    const { t } = useTranslation();

    const refreshList = () => {
        setRefresh((prevLoading) => !prevLoading);
    };

    function getDatasFromCustomerId(customerIdValue: any) {
        if (customerIdValue) {
            CustomerQuery.GetCustomerById(customerIdValue).then((res: any) => {
                setDatas(res.data);
                let activeTabName = searchParams.get('ActiveTab');
                if (activeTabName && tabList && tabList.length > 0) {
                    const matchingTab = tabList.find((tab: any) => tab.code === activeTabName);
                    if (matchingTab) {
                        setIndex(matchingTab.id);
                        setTabIndex(matchingTab.id);
                    }
                }
            });
        }
    }

    function ChoseSelect() {
        setIndex(1);
        setTabIndex(1);
        getCustomer();
    }

    const getCustomer = async () => {
        if (searchedText === '') {
            Swal.fire(t('general.error'), t('customerInformation.enterInput'), 'error');
            return;
        }

        setPageLoading(true);

        let text = searchedText.toString().trim();

        let query = {};
        if (documentType === 1) {
            if (text[0] === '0') {
                text = text.slice(1, text.length);
            }
            query = { customerPhoneNumber: text };
        } else if (documentType === 2) {
            query = { customerEmail: text };
        } else if (documentType === 3) {
            query = { customerId: text };
        }

        const queryString = new URLSearchParams(query).toString();
        CustomerQuery.GetCustomer(queryString)
            .then((res: any) => {
                if (!res?.data?.customer) {
                    Swal.fire(t('general.error'), t('customerInformation.customerNotFound'), 'error');
                    return;
                }
                setDatas(res.data);
                setCustomerId(res.data.customer.customerId);
                history.push('?ActiveTab=CustomerInformation&customerId=' + res.data.customer.customerId);
            })
            .catch(() => {
                Swal.fire(t('general.error'), t('customerInformation.customerNotFound'), 'error');
                return;
            })
            .finally(() => {
                setPageLoading(false);
            });
    };

    const onClickBreadCrumb = () => {
        setDatas('');
        setSearchedText('');
    };

    useEffect(() => {
        const urlCustomerId =
            Number(searchParams.get('customerId')) || Number(searchParams.get('CustomerId'));
        const activeCustomerId = customerId || urlCustomerId;

        if (activeCustomerId) {
            getDatasFromCustomerId(activeCustomerId);
        } else if (searchedText.length > 1) {
            getCustomer();
        }
    }, [refresh]);

    useEffect(() => {
        try {
            CustomerQuery.GetCustomerSubMenuFromRule().then((res: any) => {
                setTabDataVisibilityStatus(res.data);
            });
        } catch {
            setTabDataVisibilityStatus(null);
        }

        if (!datas) {
            let customerIdValue = Number(searchParams.get('customerId')) || Number(searchParams.get('CustomerId'));
            setCustomerId(Number(customerIdValue));
        } else {
            setCustomerId(datas.customerId);
        }
    }, []);

    useEffect(() => {
        setTablist([]);
        if (!datas && customerId) {
            getDatasFromCustomerId(customerId);
        }
    }, [customerId]);

    useEffect(() => {
        if (tabDataVisibilityStatus) {
            const tabs = [
                {
                    id: 1,
                    name: t('customerInformation.customerInformation'),
                    link: '?ActiveTab=CustomerInformation&customerId=' + customerId,
                    code: 'CustomerInformation',
                    isShow: tabDataVisibilityStatus?.showCustomerInformation,
                },
                {
                    id: 3,
                    name: t('customerInformation.orderInformation'),
                    link: '?ActiveTab=OrderInformation&customerId=' + customerId,
                    code: 'OrderInformation',
                    isShow: tabDataVisibilityStatus?.showOrderInformation,
                },
                {
                    id: 2,
                    name: t('customerInformation.addressInformation'),
                    link: '?ActiveTab=AddressInformation&customerId=' + customerId,
                    code: 'AddressInformation',
                    isShow: tabDataVisibilityStatus?.showAddressInformation,
                },
                {
                    id: 11,
                    name: t('customerInformation.customerMessages'),
                    link: '?ActiveTab=Messages&customerId=' + customerId,
                    code: 'Messages',
                    isShow: tabDataVisibilityStatus?.showMessages,
                },
                {
                    id: 5,
                    name: t('customerInformation.returnCustomer'),
                    link: '?ActiveTab=ReturnCustomer&customerId=' + customerId,
                    code: 'ReturnCustomer',
                    isShow: tabDataVisibilityStatus?.showReturnCustomer,
                },
                {
                    id: 15,
                    name: t('customerInformation.bankInstallmentInformation'),
                    link: '?ActiveTab=CustomerBasketV2&customerId=' + customerId,
                    code: 'CustomerBasketV2',
                    isShow: tabDataVisibilityStatus?.showCustomerBasketV2,
                },
                {
                    id: 13,
                    name: t('customerInformation.returnPaymentList'),
                    link: '?ActiveTab=ReturnPaymentList&customerId=' + customerId,
                    code: 'ReturnPaymentList',
                    isShow: tabDataVisibilityStatus?.showReturnPaymentList,
                },
                {
                    id: 8,
                    name: t('customerInformation.lcwMoney'),
                    link: '?ActiveTab=LcwMoney&customerId=' + customerId,
                    code: 'LcwMoney',
                    isShow: tabDataVisibilityStatus?.showLcwMoney,
                },
                {
                    id: 6,
                    name: t('customerInformation.paymentMethods'),
                    link: '?ActiveTab=PaymentMethods&customerId=' + customerId,
                    code: 'PaymentMethods',
                    isShow: tabDataVisibilityStatus?.showPaymentMethods,
                },
                {
                    id: 9,
                    name: t('customerInformation.giftCard'),
                    link: '?ActiveTab=GiftCard&customerId=' + customerId,
                    code: 'GiftCard',
                    isShow: tabDataVisibilityStatus?.showGiftCard,
                },
                {
                    id: 18,
                    name: t('customerInformation.customerShippingChangeHistory'),
                    link: '?ActiveTab=CustomerShippingHistory&customerId=' + customerId,
                    code: 'CustomerShippingHistory',
                    isShow: tabDataVisibilityStatus?.showCustomerShippingChangeHistory,
                },
                {
                    id: 10,
                    name: t('customerInformation.customerShipmentBans'),
                    link: '?ActiveTab=CustomerShipmentBans&customerId=' + customerId,
                    code: 'CustomerShipmentBans',
                    isShow: tabDataVisibilityStatus?.showCustomerShipmentBans,
                },
                {
                    id: 12,
                    name: t('customerInformation.customerPaymentLogs'),
                    link: '?ActiveTab=CustomerPaymentLogs&customerId=' + customerId,
                    code: 'CustomerPaymentLogs',
                    isShow: tabDataVisibilityStatus?.showCustomerPaymentLogs,
                },
                {
                    id: 16,
                    name: t('customerInformation.deviceIPInformation'),
                    link: '?ActiveTab=DeviceIPInformation&customerId=' + customerId,
                    code: 'DeviceIPInformation',
                    isShow: tabDataVisibilityStatus?.showDeviceIPInformation,
                },
                {
                    id: 17,
                    name: t('customerInformation.giftVoucher'),
                    link: '?ActiveTab=GiftVoucher&customerId=' + customerId,
                    code: 'GiftVoucher',
                    isShow: tabDataVisibilityStatus?.showGiftVoucher,
                },
            ];
            setTablist(tabs);
            let activeTabName = searchParams.get('ActiveTab');
            if (activeTabName && tabs.length > 0) {
                const matchingTab = tabs.find((tab) => tab.code === activeTabName);
                if (matchingTab) {
                    setIndex(matchingTab.id);
                    setTabIndex(matchingTab.id);
                }
            }
        }
    }, [tabDataVisibilityStatus, customerId]);

    return (
        <SCUIContent>
            <SCUILoadingLinear display={pageLoading} />
            <Grid
                className="customer-management"
                container
                direction="row"
                spacing={2}
                sx={{ marginLeft: '0.5rem', marginTop: '0.1rem' }}
            >
                <SCUIBreadCrumb
                    title={t('customerInformation.followCustomer')}
                    componentLink={'CustomerManagement'}
                    onClick={onClickBreadCrumb}
                />
                {datas?.customer ? (
                    <Grid container direction="row" sx={{ marginLeft: '0.5rem' }}>
                        <Grid container spacing={1}>
                            <Grid
                                sx={{ marginBottom: '1rem' }}
                                size={{
                                    xl: 12,
                                    lg: 12,
                                    md: 12,
                                    xs: 12,
                                }}
                            >
                                <CustomerCardPaper datas={datas} refresh={refreshList} />
                            </Grid>
                            <Grid
                                height="100%"
                                size={{
                                    xl: 2,
                                    lg: 3,
                                    md: 12,
                                    xs: 12,
                                }}
                            >
                                <CustomerMenuPaper
                                    tabList={tabList}
                                    tIndex={tabIndex}
                                    setTabIndex={setTabIndex}
                                    setIndex={setIndex}
                                />
                            </Grid>
                            <Grid
                                sx={{ paddingLeft: '1rem' }}
                                size={{
                                    xl: 9.5,
                                    lg: 9,
                                    md: 12,
                                    xs: 12,
                                }}
                            >
                                {tabDataVisibilityStatus?.showCustomerInformation && index === 1 && (
                                    <Grid
                                        className="customer-management-customer-information"
                                        height="30%"
                                        size={{
                                            xl: 12,
                                            lg: 12,
                                            md: 12,
                                            xs: 12,
                                        }}
                                    >
                                        <CustomerInformationPaper datas={datas} refresh={refreshList} />
                                    </Grid>
                                )}
                                {tabDataVisibilityStatus?.showCustomerInformation && index === 1 && (
                                    <Grid
                                        className="customer-management-customer-information-detail"
                                        height="50%"
                                        sx={{ paddingTop: '1rem', marginTop: '2rem' }}
                                        size={{
                                            xl: 12,
                                            lg: 12,
                                            md: 12,
                                            xs: 12,
                                        }}
                                    >
                                        <CustomerUnderMenuPaper
                                            datas={datas}
                                            refresh={refreshList}
                                            index={index}
                                            tabDataVisibilityStatus={tabDataVisibilityStatus}
                                        />
                                    </Grid>
                                )}

                                {tabDataVisibilityStatus?.showAddressInformation && index === 2 && (
                                    <Grid
                                        className="customer-management-address-information"
                                        sx={{ height: '100%' }}
                                        size={{
                                            xl: 12,
                                            lg: 12,
                                            md: 12,
                                            xs: 12,
                                        }}
                                    >
                                        <CustomerAdressInformationPaper datas={datas} />
                                    </Grid>
                                )}
                                {tabDataVisibilityStatus?.showOrderInformation && index === 3 && (
                                    <Grid
                                        className="customer-management-order-information"
                                        sx={{ height: '100%' }}
                                        size={{
                                            xl: 12,
                                            lg: 12,
                                            md: 12,
                                            xs: 12,
                                        }}
                                    >
                                        <CustomerOrderInformationPaper datas={datas} urlParams={searchParams} />
                                    </Grid>
                                )}
                                {tabDataVisibilityStatus?.showMessages && index === 11 && (
                                    <Grid
                                        className="customer-management-messages"
                                        sx={{ height: '100%' }}
                                        size={{
                                            xl: 12,
                                            lg: 12,
                                            md: 12,
                                            xs: 12,
                                        }}
                                    >
                                        <CustomerContactMessage datas={datas} />
                                    </Grid>
                                )}
                                {tabDataVisibilityStatus?.showReturnCustomer && index === 5 && (
                                    <Grid
                                        className="customer-management-return-customer"
                                        sx={{ height: '100%' }}
                                        size={{
                                            xl: 12,
                                            lg: 12,
                                            md: 12,
                                            xs: 12,
                                        }}
                                    >
                                        <CustomerReturn datas={datas} />
                                    </Grid>
                                )}
                                {tabDataVisibilityStatus?.showCustomerBasketV2 && index === 15 && (
                                    <Grid
                                        className="customer-management-customer-basket-v2"
                                        sx={{ height: '100%' }}
                                        size={{
                                            xl: 12,
                                            lg: 12,
                                            md: 12,
                                            xs: 12,
                                        }}
                                    >
                                        <CustomerBasketInfosV2 datas={datas} />
                                    </Grid>
                                )}
                                {tabDataVisibilityStatus?.showReturnPaymentList && index === 13 && (
                                    <Grid
                                        className="customer-management-return-payment-list"
                                        sx={{ height: '100%' }}
                                        size={{
                                            xl: 12,
                                            lg: 12,
                                            md: 12,
                                            xs: 12,
                                        }}
                                    >
                                        <CustomerRefundListV2 datas={datas} />
                                    </Grid>
                                )}
                                {tabDataVisibilityStatus?.showLcwMoney && index === 8 && (
                                    <Grid
                                        className="customer-management-lcw-money"
                                        sx={{ height: '100%' }}
                                        size={{
                                            xl: 12,
                                            lg: 12,
                                            md: 12,
                                            xs: 12,
                                        }}
                                    >
                                        <CustomerLcwMoney datas={datas} />
                                    </Grid>
                                )}
                                {tabDataVisibilityStatus?.showPaymentMethods && index === 6 && (
                                    <Grid
                                        className="customer-management-payment-methods"
                                        sx={{ height: '100%' }}
                                        size={{
                                            xl: 12,
                                            lg: 12,
                                            md: 12,
                                            xs: 12,
                                        }}
                                    >
                                        <CustomerPaymentMethods datas={datas} />
                                    </Grid>
                                )}
                                {tabDataVisibilityStatus?.showGiftCard && index === 9 && (
                                    <Grid
                                        className="customer-management-gift-card"
                                        sx={{ height: '100%' }}
                                        size={{
                                            xl: 12,
                                            lg: 12,
                                            md: 12,
                                            xs: 12,
                                        }}
                                    >
                                        <CustomerGiftCard datas={datas} />
                                    </Grid>
                                )}
                                {tabDataVisibilityStatus?.showCustomerShippingChangeHistory && index === 18 && (
                                    <Grid
                                        className="customer-management-customer-shipping-history"
                                        sx={{ height: '100%' }}
                                        size={{
                                            xl: 12,
                                            lg: 12,
                                            md: 12,
                                            xs: 12,
                                        }}
                                    >
                                        <CustomerShippingHistory customerData={datas} />
                                    </Grid>
                                )}
                                {tabDataVisibilityStatus?.showCustomerShipmentBans && index === 10 && (
                                    <Grid
                                        className="customer-management-customer-shipment-bans"
                                        sx={{ height: '100%' }}
                                        size={{
                                            xl: 12,
                                            lg: 12,
                                            md: 12,
                                            xs: 12,
                                        }}
                                    >
                                        <CustomerShipmentBans datas={datas} />
                                    </Grid>
                                )}
                                {tabDataVisibilityStatus?.showCustomerPaymentLogs && index === 12 && (
                                    <Grid
                                        className="customer-management-customer-payment-logs"
                                        sx={{ height: '100%' }}
                                        size={{
                                            xl: 12,
                                            lg: 12,
                                            md: 12,
                                            xs: 12,
                                        }}
                                    >
                                        <CustomerPaymentLogs data={datas} />
                                    </Grid>
                                )}
                                {tabDataVisibilityStatus?.showDeviceIPInformation && index === 16 && (
                                    <Grid
                                        className="customer-management-device-ip-information"
                                        sx={{ height: '100%' }}
                                        size={{
                                            xl: 12,
                                            lg: 12,
                                            md: 12,
                                            xs: 12,
                                        }}
                                    >
                                        <GetCustomerDeviceDetails data={datas} />
                                    </Grid>
                                )}
                                {tabDataVisibilityStatus?.showGiftVoucher && index === 17 && (
                                    <Grid
                                        className="customer-management-gift-voucher"
                                        sx={{ height: '100%' }}
                                        size={{
                                            xl: 12,
                                            lg: 12,
                                            md: 12,
                                            xs: 12,
                                        }}
                                    >
                                        <GiftVouchers customerData={datas} />
                                    </Grid>
                                )}
                            </Grid>
                        </Grid>
                    </Grid>
                ) : pageLoading ? (
                    ''
                ) : (
                    <Grid
                        size={{
                            xl: 12,
                            lg: 12,
                            md: 12,
                            xs: 12,
                        }}
                    >
                        <div
                            style={{
                                display: 'flex',
                                flexDirection: 'column',
                                alignContent: 'center',
                                justifyContent: 'center',
                                alignItems: 'center',
                            }}
                        >
                            <SCUINoRecordComponent text={' '} img={customer} />
                            <Grid
                                className="customer-management-customer-search"
                                sx={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    marginTop: '24px',
                                }}
                                size={{
                                    xl: 12,
                                    lg: 12,
                                    md: 12,
                                    xs: 12,
                                }}
                            >
                                <SCUITextFieldWithSelectBox
                                    placeholder={' '}
                                    buttonText={t('general.search')}
                                    selectList={[
                                        { value: 1, text: t('general.phoneNumber') },
                                        { value: 2, text: t('lcwMoney.email') },
                                        { value: 3, text: t('general.customerId') },
                                    ]}
                                    onChangeSelect={(event: any) => {
                                        setDocumentType(event.target.value as number);
                                    }}
                                    selectValue={documentType}
                                    onChangeTextField={(event: any) => {
                                        const value = event.target.value.trim();
                                        setSearchedText(value);
                                    }}
                                    onClickButton={() => ChoseSelect()}
                                    onKeyPressTextField={(e: any) => {
                                        if (e.key === 'Enter') {
                                            e.preventDefault();
                                            ChoseSelect();
                                        }
                                    }}
                                />
                            </Grid>
                        </div>
                    </Grid>
                )}
            </Grid>
        </SCUIContent>
    );
};
